/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'thumb-down': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M14.833 2.504c1.146-.083 1.99.952 2.271 2.15l.004.017.882 4.412c.007.032.01.065.01.098a2.265 2.265 0 01-2.265 2.264h-2.147v3.912a2.265 2.265 0 11-4.53 0v-.882a3.03 3.03 0 00-3.029-3.03H3.382A1.382 1.382 0 012 10.063V3.887c0-.764.619-1.383 1.382-1.383h1.765c.602 0 1.114.385 1.304.922a3.137 3.137 0 012.225-.922h6.157zM5.53 3.887a.382.382 0 00-.382-.383H3.382A.382.382 0 003 3.887v6.176c0 .211.171.382.382.382H5.53V3.887zm1 6.59V5.65c0-1.185.962-2.147 2.147-2.147h6.177a.5.5 0 00.042-.002c.411-.034.994.362 1.234 1.373l.87 4.351a1.265 1.265 0 01-1.264 1.22h-2.647a.5.5 0 00-.5.5v4.411a1.265 1.265 0 11-2.53 0v-.882a4.03 4.03 0 00-3.529-3.999z" _fill="#1F222C"/>'
  }
})
